import permissions from '@/constants/PERMISSIONS';
import {CommonUserDataState} from '@/redux/commonUserData/stateTypes';
import {StoreStateShape} from '@/redux/store/storeStateTypes';

const {READ_URGENT_ALERTS} = permissions;

const EMPTY_PHONE_CALL_DATA: CommonUserDataState['phoneCallData'] = {
    callerPatientId: null,
    callerFirstName: '',
    callerLastName: '',
    callerSex: '',
    callerDOB: '',
    isOutboundCallActive: false,
    showAnswerButton: false,
    awsConnectAgentStatus: 'Offline',
    initialContactId: '',
    sourceAgentEmail: '',
    queueARN: [],
    needToShowCPPPanel: false,
    isDoNotDisturbedEnabled: false,
};
const EMPTY_EMPLOYMENT: CommonUserDataState['employment'] = {};
const EMPTY_FEATURES: CommonUserDataState['features'] = {};
const EMPTY_MISSION_CONTROL_IDS: CommonUserDataState['missionControlIds'] = [];
const EMPTY_PERMISSIONS: CommonUserDataState['permissions'] = {};
const EMPTY_USER: CommonUserDataState['user'] = {roles: []};

const getCommonUserData = ({commonUserDataReducer}: StoreStateShape) => commonUserDataReducer;

const urgentAlertsPermissionsSelector = (state: StoreStateShape) =>
    Boolean((getCommonUserData(state)?.permissions || EMPTY_PERMISSIONS)[READ_URGENT_ALERTS]);

const phoneCallDataSelector = (state: StoreStateShape) =>
    getCommonUserData(state)?.phoneCallData || EMPTY_PHONE_CALL_DATA;
const missionControlIdsSelector = (state: StoreStateShape) =>
    getCommonUserData(state)?.missionControlIds || EMPTY_MISSION_CONTROL_IDS;
const userSelector = (state: StoreStateShape) => getCommonUserData(state)?.user || EMPTY_USER;
const activeVideoCallsSelector = (state: StoreStateShape) => state.callReducer.activeVideoCallsList;
const employmentSelector = (store: StoreStateShape) => getCommonUserData(store)?.employment || EMPTY_EMPLOYMENT;
const patientIdSelector = (store: StoreStateShape) => store.patientInfoReducer?.patientInfo?.id;
const featureFlagSelector = (state: StoreStateShape) =>
    Boolean((getCommonUserData(state)?.features || EMPTY_FEATURES).AllowPatientPrecaution);

const selectClinicName = (state: StoreStateShape) => {
    const selectedMissionControl = getCommonUserData(state)?.selectedMissionControl;
    const missionControls = state.commonDataReducer.missionControls;
    const activeMissionControl = missionControls.find((item) => item.id === selectedMissionControl);
    return activeMissionControl?.fullName;
};

const selectBuildInfo = ({commonDataReducer: {buildInfo}}: StoreStateShape) => buildInfo;

const isDisplayMissedCallsLogEnabledSelector = (state: StoreStateShape) => ({
    isDisplayMissedCallsLogEnabled: Boolean(
        (getCommonUserData(state)?.features || EMPTY_FEATURES).DisplayMissedCallsLog,
    ),
});

const isVideoCallsEnabledSelector = (state: StoreStateShape) => ({
    isVideoCallsEnabled: Boolean((getCommonUserData(state)?.features || EMPTY_FEATURES).CapabilityVideoCalls),
});

export {
    activeVideoCallsSelector,
    employmentSelector,
    featureFlagSelector,
    isDisplayMissedCallsLogEnabledSelector,
    isVideoCallsEnabledSelector,
    missionControlIdsSelector,
    patientIdSelector,
    phoneCallDataSelector,
    selectBuildInfo,
    selectClinicName,
    urgentAlertsPermissionsSelector,
    userSelector,
};
